class VariantThicknessPicker extends HTMLElement {
  constructor() {
    super();
    this.variantSelects = this.closest('variant-selects');
    if (!this.variantSelects) return;

    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (!event.target.classList.contains('js-variant-input')) return;

    // Simply trigger the native change event on the radio input
    // The theme's variant-selects component will handle the rest
    const nativeEvent = new Event('change', { bubbles: true });
    event.target.dispatchEvent(nativeEvent);
  }
}

customElements.define('variant-thickness-picker', VariantThicknessPicker);
